import { colors } from '@material-ui/core'

const white = '#FFFFFF'
const black = '#000000'

const palette = {
  black,
  white,
  primary: {
    contrastText: white,
    dark: colors.indigo[900],
    main: '#FEC311',
    light: colors.indigo[100],
  },
  secondary: {
    contrastText: white,
    dark: colors.grey[900],
    main: colors.grey[600],
    light: colors.grey[400],
    superLight: colors.grey[100],
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.blueGrey[900],
    menu: '#546E7A',
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
  },
  background: {
    default: '#F4F6F8',
    topBar: '#333333',
    paper: white,
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[300],
}

export default palette
